import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function para combinar clases de Tailwind CSS
 * Combina clsx para condicionales y tailwind-merge para evitar conflictos
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}